import React from "react";
import PropTypes from "prop-types";
import { SPEED_PICKER, OPTION_CLASS, LABEL, BUTTON } from "./Classes";

var SpeedPicker = function SpeedPicker(_ref) {
  var speed = _ref.speed,
      selectSpeed = _ref.selectSpeed;
  return React.createElement("div", {
    className: OPTION_CLASS + " " + SPEED_PICKER
  }, React.createElement("div", {
    className: LABEL
  }, "speed"), [1, 2, 3, 4, 5].map(function (speedOption) {
    return React.createElement("button", {
      key: speedOption,
      className: BUTTON + " " + (speedOption === speed ? "is-active" : null),
      onClick: function onClick() {
        return selectSpeed(speedOption);
      }
    }, speedOption, "x");
  }));
};

SpeedPicker.propTypes = process.env.NODE_ENV !== "production" ? {
  speed: PropTypes.number.isRequired,
  selectSpeed: PropTypes.func.isRequired
} : {};
export default SpeedPicker;